mutation RequestYouTubeConnectUrl($returnOrigin: String) {
  connectUrl: StreamToolsRequestYouTubeConnectUrl(returnOrigin: $returnOrigin) {
    url
    expiresAt
  }
}
